<template>
	<div>
		<div v-for="item in items">
			<tpl-text v-if="item.type === 708" :data="item"></tpl-text>
			<tpl-video v-if="item.type === 709" :data="item"></tpl-video>
			<tpl-image v-if="item.type === 702" :data="item"></tpl-image>
			<tpl-menu v-if="item.type === 603" :data="item"></tpl-menu>
			<tpl-banner v-if="item.type === 601" :data="item"></tpl-banner>
			<tpl-notice v-if="item.type === 704" :data="item"></tpl-notice>
			<tpl-search v-if="item.type === 703" :data="item"></tpl-search>
			<tpl-magic v-if="item.type === 701" :data="item"></tpl-magic>
			<tpl-product v-if="item.type === 201" :data="item" :products="products"></tpl-product>
			<tpl-coupon v-if="item.type === 301" :data="item" :coupons="coupons"></tpl-coupon>
			<tpl-shop-header v-if="item.type === 101" :data="item" :shop="shop"></tpl-shop-header>
			<tpl-user-header v-if="item.type === 2001" :data="item" :user="user"></tpl-user-header>
			<tpl-user-order v-if="item.type === 2002" :data="item" :order="order"></tpl-user-order>
			<tpl-avatar ref="avatar" v-if="item.type === 520" :data="item"></tpl-avatar>
      <tpl-system-menu ref="avatar" v-if="item.type === 521" :data="item"></tpl-system-menu>
			<tpl-ai-asset v-if="item.type === 2005" :data="item"></tpl-ai-asset>
		</div>
	</div>
</template>

<script>
	import TplText from '@/components/tpl/text.vue'
	import TplImage from '@/components/tpl/image.vue'
	import TplVideo from '@/components/tpl/video.vue'
	import TplMenu from '@/components/tpl/menu.vue'
	import TplBanner from '@/components/tpl/banner.vue'
	import TplNotice from '@/components/tpl/notice.vue'
	import TplSearch from '@/components/tpl/search.vue'
	import TplMagic from '@/components/tpl/magic.vue'
	import TplProduct from '@/components/tpl/product.vue'
	import TplCoupon from '@/components/tpl/coupon.vue'
	import TplShopHeader from '@/components/tpl/shop_header.vue'
	import TplUserHeader from '@/components/tpl/user_header.vue'
	import TplUserOrder from '@/components/tpl/user_order.vue'
	import TplAvatar from '@/components/tpl/avatar.vue'
  import TplSystemMenu from '@/components/tpl/system_menu.vue'
	import TplAiAsset from '@/components/tpl/ai_asset.vue'


	export default {
		data() {
			return {}
		},
		components: {
			TplText,
			TplImage,
			TplVideo,
			TplMenu,
			TplBanner,
			TplNotice,
			TplSearch,
			TplMagic,
			TplProduct,
			TplCoupon,
			TplShopHeader,
			TplUserHeader,
			TplUserOrder,
			TplAvatar,
      TplSystemMenu,
			TplAiAsset


		},
		props: {
			items: {
				type: Array,
				default: () => []
			},

		},
		methods: {

		}
	}
</script>

<style>
</style>